export default function ($scope, $compile, map, google) {
    map.controls[google.maps.ControlPosition.TOP_CENTER].push(document.getElementById("search-places"));
    
    var search = new google.maps.places.Autocomplete(document.getElementById("pac-input"), {componentRestrictions: {country: 'pt'}});
    search.bindTo('bounds', map);

    google.maps.event.addListener(search, 'place_changed', function () {
        var place = search.getPlace();

        if (!place.geometry) {
            return;
        }

        if ($scope.place) {
            $scope.place.setMap(null);
        }

        $scope.place = new google.maps.Marker({
            position: new google.maps.LatLng(place.geometry.location),
            map: map,
            label: place.name
        });

        $scope.place.setIcon("http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|FE7569");

        $scope.place.setPosition(place.geometry.location);
        $scope.place.setVisible(true);

        map.setCenter(place.geometry.location);
        map.setZoom(16);
    });
    
    //refresh fcn
    return function() {}
}




// WEBPACK FOOTER //
// ./src/search/setup.js